import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import i18n from "../../../constants/i18n";
import KhattabatPasswordForm from "../../../routes/csr/change-password/password-form/KhattabatPasswordForm";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";

const KhattabatChangePasswordDialog = withLiteObserverAndTheme(() => (
  <Dialog open maxWidth="xs" fullWidth>
    <DialogTitle>{i18n.get("CHANGE_PASSWORD")}</DialogTitle>
    <DialogContent>
      <Box sx={{ pt: 1 }}>
        <KhattabatPasswordForm />
      </Box>
    </DialogContent>
  </Dialog>
));
export default KhattabatChangePasswordDialog;
